import { Box, TextField, Typography } from "@mui/material";
import { CheckCircle } from "@mui/icons-material"; // For the button icon
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

// Reusable component for inline editing
const EditableBox = ({ label, value, onSave, isEditable }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempValue, setTempValue] = useState(value);

  useEffect(() => {
    setTempValue(value);
  }, [value]);

  const handleBlur = () => {
    setIsEditing(false);
    if (tempValue !== value) {
      onSave(tempValue);
    }
  };

  if (isEditing) {
    return (
      <Box sx={{ mb: 2 }}>
        <Typography fontWeight={600} sx={{ mb: 1 }}>
          {label}:
        </Typography>
        <TextField
          fullWidth
          multiline
          autoFocus
          value={tempValue}
          onChange={(e) => setTempValue(e.target.value)}
          onBlur={handleBlur}
          minRows={3}
          maxRows={6}
          placeholder={`Enter ${label}...`}
          sx={{
            bgcolor: "background.paper",
            "& .MuiOutlinedInput-root": {
              padding: 1.5,
            },
          }}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Typography fontWeight={600} sx={{ mb: 1 }}>
        {label}:
      </Typography>
      <Box
        onClick={() => (isEditable ? setIsEditing(true) : "")}
        sx={{
          maxHeight: 150,
          minHeight: 80, // Ensures shape consistency
          overflowY: "auto",
          p: 1.5,
          bgcolor: "grey.100",
          borderRadius: 2,
          cursor: "pointer",
          border: "1px solid transparent",
          transition: "all 0.2s",
          "&:hover": {
            bgcolor: "grey.200",
            border: "1px solid #bdbdbd",
          },
        }}
      >
        {value || (
          <Typography color="text.secondary" variant="body2">
            {isEditable ? "Click to edit..." : ""}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

EditableBox.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  onSave: PropTypes.func.isRequired,
  isEditable: PropTypes.bool.isRequired,
};

export default EditableBox;
